/* eslint-disable import/no-cycle */
import { LogsInitConfiguration } from "@datadog/browser-logs";
import { RumInitConfiguration } from "@datadog/browser-rum";

import { getEnv } from "./util";
import redactUrl from "./util/redactUrl";

const env = getEnv(window.location);

const version = process.env.BRANCH_OR_TAG || "unspecified";

const firebaseProduction = {
    apiKey: "AIzaSyBqpwriBEqjp1kVG0_PkruuWBg4VWQQirc",
    authDomain: "volley-web-production.firebaseapp.com",
    projectId: "volley-web-production",
    messagingSenderId: "884471169963",
    appId: "1:884471169963:web:65e228d70e0142ade948ee",
};

const firebaseStaging = {
    apiKey: "AIzaSyC3aFyszleli58YwXsYwidflsQGfFQnjns",
    authDomain: "volley-web-staging.firebaseapp.com",
    projectId: "volley-web-staging",
    messagingSenderId: "1070126318692",
    appId: "1:1070126318692:web:be4c3943610fd9172a4b71",
};

const firebaseRc = {
    apiKey: "AIzaSyAI2sRJcifXFyoAZmDeKF8upK2-OczW7Vg",
    authDomain: "volley-web-rc.firebaseapp.com",
    projectId: "volley-web-rc",
    messagingSenderId: "191844139284",
    appId: "1:191844139284:web:562e9f50febf9de46d4201",
};

const datadogLogging: LogsInitConfiguration = {
    clientToken: "pubbe07b92048ab4c7e176d8d18d4678af9",
    site: "us5.datadoghq.com",
    forwardErrorsToLogs: env !== "local", // forward errors if we're not local
    // forwardErrorsToLogs stopped covering console.error in SDK v7
    forwardConsoleLogs: env !== "local" ? ["error"] : [],
    sessionSampleRate: 100,
    version,
    beforeSend: (log) => {
        if (log.view) {
            log.view.url = redactUrl(log.view.url);
            log.view.referrer = redactUrl(log.view.referrer);
        }
        return true;
    },
};

const datadogRum: RumInitConfiguration = {
    applicationId: "0df780c6-2fb1-4255-911a-85a3fbb83196",
    clientToken: "pubbe07b92048ab4c7e176d8d18d4678af9",
    site: "us5.datadoghq.com",
    service: "webby-app",
    env,
    version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    defaultPrivacyLevel: "mask-user-input",
    trackResources: true,
    allowedTracingUrls: [
        "https://staging.onevolley.com",
        "https://rc.onevolley.com",
        "https://play.onevolley.com",
        "https://app.onevolley.com",
        "https://staging.getvolley.com",
        "https://rc.getvolley.com",
        "https://play.getvolley.com",
        "https://app.getvolley.com",
        "https://scottm.ngrok.app",
    ],
    // SDK v7 defaults this on, adding a `baggage` header with the RUM session
    // and user IDs to traced requests. webby-server's OpenTelemetry re-sends
    // incoming baggage on its own outgoing HTTP calls, which would hand those
    // IDs to third-party APIs, and Cloud Trace does nothing with them.
    propagateTraceBaggage: false,
    beforeSend: (event) => {
        // Returning false will prevent the event from being sent
        // we cannot discard page views, but we can discard actions
        if (event.view.url.includes("/admin") && event.type !== "view") {
            return false;
        }
        event.view.url = redactUrl(event.view.url);
        event.view.referrer = redactUrl(event.view.referrer);
        if (event.type === "resource") {
            event.resource.url = redactUrl(event.resource.url);
        }
        return true;
    },
};

let firebase = firebaseStaging;
if (env === "rc") {
    firebase = firebaseRc;
} else if (env === "production") {
    firebase = firebaseProduction;
}

const intercomProduction = {
    appId: "qmxtzegi",
    name: "production-workspace",
};

const intercomTest = {
    appId: "v0s3kwm6",
    name: "development-workspace",
};
let intercom = intercomTest;
if (env === "production") {
    intercom = intercomProduction;
}

// Each hosted Club-in-Club verifies tokens against exactly one Firebase project, so this has
// to name the deployment that shares ours -- a token minted for one project cannot be redeemed
// against a deployment configured for another. Chosen the same way as `firebase` and
// `intercom` above:
//   - staging (volley-web-staging) -> clubinclub-staging.getvolley.com, staging's own deployment;
//   - production (and rc)          -> clubinclub.getvolley.com;
//   - local                        -> a Club-in-Club run from its own repo on 5050.
// It must agree with webby-server's CLUB_IN_CLUB_BASE_URL for the same environment, which the
// widget's tap-through uses (k8s-config overlays).
let clubInClubUrl = "https://clubinclub.getvolley.com/";
if (env === "staging") {
    clubInClubUrl = "https://clubinclub-staging.getvolley.com/";
} else if (env === "local") {
    clubInClubUrl = "http://localhost:5050/";
}

const config = {
    firebase,
    datadogRum,
    datadogLogging,
    intercom,
    env,
    version,
    clubInClubUrl,
};

export default config;
